import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getSearch = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DocumentManage/Search",
    params
  );
};

const getById = (id) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DocumentManage/GetById?docId=" + id
  );
};

const updateData = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/DocumentManage/Update",
    params
  );
};

export { getSearch, getById, updateData };
